'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var fieldHint = require('./field-hint-cc714695.js');

var StyledContainer = styled__default.span(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  padding-top: 4px;\n  padding-right: 3px;\n  font-style: italic;\n  font-size: 12px;\n  color: ", ";\n"], ["\n  padding-top: 4px;\n  padding-right: 3px;\n  font-style: italic;\n  font-size: 12px;\n  color: ",
    ";\n"])), function (_a) {
    var theme = _a.theme, length = _a.length, maxLength = _a.maxLength;
    return (length && (length > maxLength)
        ? theme.colors.admin.pink
        : theme.colors.greys.adminGreyDark);
});
var LengthIndicator = function (_a) {
    var dataTestId = _a.dataTestId, maxLength = _a.maxLength, length = _a.length, restProps = tslib_es6.__rest(_a, ["dataTestId", "maxLength", "length"]);
    return (React__default.createElement(StyledContainer, tslib_es6.__assign({ "data-testid": dataTestId, length: length, maxLength: maxLength }, restProps), (length !== null && length !== void 0 ? length : 0) + "/" + maxLength));
};
var templateObject_1;

// eslint-disable-next-line arrow-body-style
var convertToString = function (value) {
    return value !== null && value !== undefined ? String(value) : undefined;
};

var StyledMessagesContainer = styled__default.div(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: baseline;\n  justify-content: ", ";\n"], ["\n  display: flex;\n  align-items: baseline;\n  justify-content: ", ";\n"])), function (_a) {
    var errorText = _a.errorText, hint = _a.hint;
    return (errorText || hint ? 'space-between' : 'flex-end');
});
var Messages = function (_a) {
    var errorText = _a.errorText, hint = _a.hint, dataCy = _a.dataCy, dataTestId = _a.dataTestId, maxCharLength = _a.maxCharLength, value = _a.value, _b = _a.hintAlign, hintAlign = _b === void 0 ? 'left' : _b;
    var strValue = convertToString(value);
    var length = strValue !== undefined ? strValue.length : undefined;
    return (React__default.createElement(StyledMessagesContainer, { errorText: errorText, hint: hint },
        errorText && (React__default.createElement(fieldHint.FieldHint, { dataCy: dataCy, dataTestId: dataTestId, variant: "error" }, errorText)),
        hint && !errorText && (React__default.createElement(fieldHint.FieldHint, { dataCy: dataCy, dataTestId: dataTestId, variant: "hint", align: hintAlign }, hint)),
        maxCharLength && React__default.createElement(LengthIndicator, { dataTestId: "length-indicator", maxLength: maxCharLength, length: length })));
};
Messages.defaultProps = {
    dataCy: undefined,
    dataTestId: undefined,
    value: undefined,
    maxCharLength: undefined,
    errorText: undefined,
    hint: undefined,
    hintAlign: 'left',
};
var templateObject_1$1;

exports.Messages = Messages;
exports.convertToString = convertToString;
